import Axios from "axios";
import {
  SET_RECEIPT_AND_PAYMENT_REPORT,
  UNSET_RECEIPT_AND_PAYMENT_REPORT,
} from "@/store/mutation-types";
import {
  getReceiptAndPaymentReport,
} from "@/store/api";

const state = {
  receiptAndPaymentReport: [],
};

const getters = {
  getReceiptAndPaymentReport(state) {
    return state.receiptAndPaymentReport;
  },
};

const mutations = {
  [SET_RECEIPT_AND_PAYMENT_REPORT](state, data) {
    state.receiptAndPaymentReport = data;
  },
  [UNSET_RECEIPT_AND_PAYMENT_REPORT](state) {
    state.receiptAndPaymentReport = [];
  },
};

const actions = {
  getReceiptAndPayment({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getReceiptAndPaymentReport}`, { params: data })
        .then((response) => {
          commit(SET_RECEIPT_AND_PAYMENT_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_RECEIPT_AND_PAYMENT_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

